<template>
  <wd-config-provider :theme-vars="themeVars">
    <slot />
    <wd-toast />
    <wd-message-box />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import { ConfigProviderThemeVars } from 'wot-design-uni'

const themeVars = {
  colorTheme: '#ff7500',
  buttonPrimaryBgColor: '#ff7500',
  buttonPrimaryColor: '#fff',
}
</script>
<style scoped></style>
